"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioButtonGroup = _interopRequireDefault(require("../RadioButton/RadioButtonGroup"));

var _ItemPicker = require("./ItemPicker.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ItemPicker = function ItemPicker(_ref) {
  var id = _ref.id,
      items = _ref.items,
      defaultValue = _ref.defaultValue,
      selectedValue = _ref.selectedValue,
      onChange = _ref.onChange;
  return _react["default"].createElement(_ItemPicker.ItemPickerStyles, null, _react["default"].createElement(_RadioButtonGroup["default"], {
    isLayoutHorizontal: true,
    id: id,
    onChange: onChange,
    items: items,
    selectedValue: selectedValue,
    defaultValue: defaultValue
  }));
};

ItemPicker.defaultProps = {
  id: "",
  items: [],
  defaultValue: "",
  selectedValue: "",
  onChange: null
};
ItemPicker.props = {
  id: _propTypes["default"].string,
  items: _propTypes["default"].array,
  defaultValue: _propTypes["default"].string,
  selectedValue: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
var _default = ItemPicker;
exports["default"] = _default;